import { render, staticRenderFns } from "./ConsentToReceiveElectronicCommunication.vue?vue&type=template&id=278bf423"
import script from "./ConsentToReceiveElectronicCommunication.vue?vue&type=script&lang=js"
export * from "./ConsentToReceiveElectronicCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports